/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MessageBannerCarousel_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"messageHelpers_viewer">;
    readonly " $refType": "MessageBannerCarousel_viewer";
};
export type MessageBannerCarousel_viewer$data = MessageBannerCarousel_viewer;
export type MessageBannerCarousel_viewer$key = {
    readonly " $data"?: MessageBannerCarousel_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"MessageBannerCarousel_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "MessageBannerCarousel_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "messageHelpers_viewer",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": "promoCodeMessaging",
          "name": "featureFlag",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "promoCodeMessaging"
            }
          ],
          "storageKey": "featureFlag(feature:\"promoCodeMessaging\")"
        }
      ]
    }
  ]
};
(node as any).hash = '1bdb8175fbff52b13d3ff0f873c658d1';
export default node;
